<template>
  <head>

    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


  </head>

  <body data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Department Management</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                    <li class="breadcrumb-item active">Departments</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Department Management -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h4 class="card-title mb-1">All Departments ({{filteredDepartments.length}})</h4>
                      <p class="text-muted mb-0">Manage your organization departments</p>
                    </div>
                    <div>
                      <button
                          v-if="getRight('CREATE DEPARTMENT')"
                          @click="openCreateModal()"
                          type="button"
                          class="btn btn-primary">
                        <i class="mdi mdi-plus-circle me-1"></i>Create Department
                      </button>
                    </div>
                  </div>

                  <div v-if="message!==null" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{message}}
                    <button type="button" class="btn-close" @click="message=null"></button>
                  </div>

                  <div v-if="successMessage!==null" class="alert alert-success alert-dismissible fade show" role="alert">
                    <i class="mdi mdi-check-circle-outline me-2"></i>
                    {{successMessage}}
                    <button type="button" class="btn-close" @click="successMessage=null"></button>
                  </div>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <input
                          v-model="searchQuery"
                          type="text"
                          class="form-control"
                          placeholder="Search departments...">
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex gap-2 justify-content-end">
                        <button
                            @click="filterStatus='all'"
                            class="btn btn-sm"
                            :class="filterStatus==='all' ? 'btn-primary' : 'btn-outline-primary'">
                          All ({{allCount}})
                        </button>
                        <button
                            @click="filterStatus='active'"
                            class="btn btn-sm"
                            :class="filterStatus==='active' ? 'btn-success' : 'btn-outline-success'">
                          Active ({{activeCount}})
                        </button>
                        <button
                            @click="filterStatus='disabled'"
                            class="btn btn-sm"
                            :class="filterStatus==='disabled' ? 'btn-warning' : 'btn-outline-warning'">
                          Disabled ({{disabledCount}})
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                    <table class="table table-hover table-striped table-sm font-12 sources-table">
                      <thead class="table-light sticky-top">
                      <tr class="font-weight-bold text-black">
                        <th scope="col" style="width: 50px;">No</th>
                        <th scope="col">Department Name</th>
                        <th scope="col" style="width: 100px;">Status</th>
                        <th scope="col" style="width: 180px;" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="filteredDepartments.length === 0">
                        <td colspan="4" class="text-center text-muted py-4">
                          <i class="mdi mdi-folder-open-outline" style="font-size: 48px;"></i>
                          <p class="mb-0 mt-2">No departments found</p>
                        </td>
                      </tr>
                      <tr v-for="(item, index) in filteredDepartments" :key="item.id">
                        <td>{{index+1}}.</td>
                        <td>
                                                        <span :class="item.status === 'disabled' ? 'text-muted' : ''">
                                                            {{item.department}}
                                                        </span>
                        </td>
                        <td>
                                                        <span
                                                            class="badge"
                                                            :class="item.status === 'disabled' ? 'bg-warning' : 'bg-success'">
                                                            {{ item.status === 'disabled' ? 'Disabled' : 'Active' }}
                                                        </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                                v-if="getRight('UPDATE DEPARTMENT')"
                                @click="openEditModal(item)"
                                type="button"
                                class="btn btn-outline-primary"
                                title="Edit">
                              <i class="mdi mdi-pencil"></i>
                            </button>

                            <button
                                v-if="getRight('DISABLE DEPARTMENT')"
                                @click="toggleDepartmentStatus(item)"
                                type="button"
                                :class="item.status === 'disabled' ? 'btn btn-outline-success' : 'btn btn-outline-warning'"
                                :title="item.status === 'disabled' ? 'Enable' : 'Disable'">
                              <i :class="item.status === 'disabled' ? 'mdi mdi-check-circle' : 'mdi mdi-cancel'"></i>
                            </button>

                            <button
                                v-if="getRight('DELETE DEPARTMENT')"
                                @click="confirmDelete(item)"
                                type="button"
                                class="btn btn-outline-danger"
                                title="Delete">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-light">
                      <tr>
                        <th colspan="4">
                          <strong>Total: {{filteredDepartments.length}} department(s)</strong>
                        </th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
              </div>
            </div>

          </div>


          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Create/Edit Department Modal -->
      <div class="modal fade" id="departmentModal" tabindex="-1" aria-labelledby="departmentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" :class="update ? 'bg-success text-white' : 'bg-primary text-white'">
              <h5 class="modal-title text-white" id="departmentModalLabel">
                <i :class="update ? 'mdi mdi-pencil-outline me-2' : 'mdi mdi-plus-circle-outline me-2'"></i>
                {{ update ? 'Update Department' : 'Create New Department' }}
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="modalDepartmentName" class="form-label">
                  Department Name<strong class="text-danger">*</strong>
                </label>
                <input
                    v-model="department"
                    type="text"
                    class="form-control"
                    id="modalDepartmentName"
                    placeholder="Enter department name"
                    @keyup.enter="saveDepartment()">
                <small class="text-muted">Enter a unique name for the department</small>
              </div>

              <div v-if="modalMessage!==null" class="alert alert-danger alert-dismissible fade show" role="alert">
                <i class="mdi mdi-alert-circle-outline me-2"></i>
                {{modalMessage}}
                <button type="button" class="btn-close" @click="modalMessage=null"></button>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i>Cancel
              </button>
              <button
                  type="button"
                  :class="update ? 'btn btn-success' : 'btn btn-primary'"
                  @click="saveDepartment()">
                <i :class="update ? 'mdi mdi-update me-1' : 'mdi mdi-content-save me-1'"></i>
                {{ update ? 'Update Department' : 'Save Department' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Confirmation Modal -->
      <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title text-white" id="deleteModalLabel">
                <i class="mdi mdi-alert-circle-outline me-2"></i>Confirm Delete
              </h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="alert alert-warning" role="alert">
                <i class="mdi mdi-alert me-2"></i>
                <strong>Warning!</strong> This action cannot be undone.
              </div>

              <p class="mb-3">You are about to delete the department:</p>
              <div class="alert alert-secondary">
                <strong>{{ departmentToDelete?.department }}</strong>
              </div>

              <p class="mb-2">To confirm deletion, please type <strong class="text-danger">DELETE</strong> in the box below:</p>
              <input
                  v-model="deleteConfirmText"
                  type="text"
                  class="form-control"
                  placeholder="Type DELETE to confirm"
                  @keyup.enter="deleteConfirmText === 'DELETE' ? deleteDepartment() : null">

              <small class="text-muted">Note: This will permanently remove the department from the system.</small>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i>Cancel
              </button>
              <button
                  type="button"
                  class="btn btn-danger"
                  :disabled="deleteConfirmText !== 'DELETE'"
                  @click="deleteDepartment()">
                <i class="mdi mdi-delete me-1"></i>Delete Department
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Status Toggle Confirmation Modal -->
      <div class="modal fade" id="statusModal" tabindex="-1" aria-labelledby="statusModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" :class="departmentToToggle?.status === 'disabled' ? 'bg-success text-white' : 'bg-warning text-dark'">
              <h5 class="modal-title" id="statusModalLabel">
                <i class="mdi mdi-help-circle-outline me-2"></i>Confirm Status Change
              </h5>
              <button type="button" class="btn-close" :class="departmentToToggle?.status === 'disabled' ? 'btn-close-white' : ''" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="mb-3">
                Are you sure you want to
                <strong>{{ departmentToToggle?.status === 'disabled' ? 'ENABLE' : 'DISABLE' }}</strong>
                this department?
              </p>
              <div class="alert alert-secondary">
                <strong>{{ departmentToToggle?.department }}</strong>
              </div>
              <p class="text-muted small mb-0">
                {{ departmentToToggle?.status === 'disabled'
                  ? 'Enabling this department will make it available for use in the system.'
                  : 'Disabling this department will hide it from active lists but preserve all data.' }}
              </p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i>Cancel
              </button>
              <button
                  type="button"
                  :class="departmentToToggle?.status === 'disabled' ? 'btn btn-success' : 'btn btn-warning'"
                  @click="updateDepartmentStatus()">
                <i :class="departmentToToggle?.status === 'disabled' ? 'mdi mdi-check-circle me-1' : 'mdi mdi-cancel me-1'"></i>
                {{ departmentToToggle?.status === 'disabled' ? 'Enable' : 'Disable' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Best Birdy
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Best Birdy Billing System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>

  <!-- Bootstrap Bundle with Popper (for modals) -->

  </body>
</template>

<script>

/* eslint-disable */

import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {biller, execute, getRight} from "@/api";

export default {
  name: "Department",
  components: {NavigationBar},
  data() {
    return{
      permission:"",
      message: null,
      successMessage: null,
      modalMessage: null,
      id:'',
      update:false,
      departments:[],
      department:'',
      searchQuery: '',
      filterStatus: 'all', // 'all', 'active', 'disabled'
      departmentToDelete: null,
      deleteConfirmText: '',
      departmentToToggle: null
    }
  },
  computed: {
    filteredDepartments() {
      let filtered = this.departments;

      // Filter by status
      if (this.filterStatus === 'active') {
        filtered = filtered.filter(d => d.status !== 'disabled');
      } else if (this.filterStatus === 'disabled') {
        filtered = filtered.filter(d => d.status === 'disabled');
      }

      // Filter by search query
      if (this.searchQuery.trim() !== '') {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(d =>
            d.department.toLowerCase().includes(query)
        );
      }

      return filtered;
    },
    allCount() {
      return this.departments.length;
    },
    activeCount() {
      return this.departments.filter(d => d.status !== 'disabled').length;
    },
    disabledCount() {
      return this.departments.filter(d => d.status === 'disabled').length;
    }
  },
  watch: {

  },

  mounted() {
    this.permission = sessionStorage.getItem("permission")
    this.getDepartment()
    this.menuAccess()

    // Initialize modals using Bootstrap global instance (loaded via CDN)
    this.$nextTick(() => {
      // Add event listener for department modal close
      const departmentModalEl = document.getElementById('departmentModal');
      if (departmentModalEl) {
        departmentModalEl.addEventListener('hidden.bs.modal', () => {
          this.cancelUpdate();
        });
      }
    });
  },
  methods:{
    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Department");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });
    },
    getRight(type){
      return getRight(type)
    },
    gotTo(route){
      router.push(route)
    },
    openCreateModal(){
      this.update = false
      this.department = ''
      this.id = ''
      this.modalMessage = null

      // Show modal using vanilla JavaScript
      const departmentModalEl = document.getElementById('departmentModal');
      if (departmentModalEl) {
        const modal = new window.bootstrap.Modal(departmentModalEl);
        modal.show();
      }
    },
    openEditModal(item){
      this.update = true
      this.department = item.department
      this.id = item.id
      this.modalMessage = null

      // Show modal using vanilla JavaScript
      const departmentModalEl = document.getElementById('departmentModal');
      if (departmentModalEl) {
        const modal = new window.bootstrap.Modal(departmentModalEl);
        modal.show();
      }
    },
    cancelUpdate(){
      this.update = false
      this.department = ''
      this.id = ''
      this.message = null
      this.successMessage = null
      this.modalMessage = null
    },
    saveDepartment(){
      if(this.department.trim() === ''){
        this.modalMessage = 'Please enter a department name'
        return
      }

      this.modalMessage = null
      this.message = null
      this.successMessage = null

      const data = new FormData();
      data.append("function", "addDepartment");
      data.append("department", this.department.trim());
      data.append("update", this.update);
      data.append("id", this.id);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) =>{
            if (res.data.success) {
              this.successMessage = this.update
                  ? 'Department updated successfully!'
                  : 'Department created successfully!';

              // Hide modal using vanilla JavaScript
              const departmentModalEl = document.getElementById('departmentModal');
              if (departmentModalEl) {
                const modal = window.bootstrap.Modal.getInstance(departmentModalEl);
                if (modal) {
                  modal.hide();
                }
              }

              this.department = ''
              this.update = false
              this.id = ''
              this.modalMessage = null
              this.getDepartment()

              // Clear success message after 3 seconds
              setTimeout(() => {
                this.successMessage = null
              }, 3000);
            } else {
              this.modalMessage = res.data.message
            }
          })
          .catch((e) => {
            this.modalMessage = e.message
          });
    },
    getDepartment(){
      this.message = null
      const data = new FormData();
      data.append("function", "getDepartment");
      execute(data, biller)
          .then((res) =>{
            if (res.data.success) {
              this.departments = res.data.data.departments
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    confirmDelete(item){
      this.departmentToDelete = item
      this.deleteConfirmText = ''

      // Show modal using vanilla JavaScript
      const deleteModalEl = document.getElementById('deleteModal');
      if (deleteModalEl) {
        const modal = new window.bootstrap.Modal(deleteModalEl);
        modal.show();
      }
    },
    deleteDepartment(){
      if(this.deleteConfirmText !== 'DELETE'){
        return
      }

      const data = new FormData();
      data.append("function", "deleteDepartment");
      data.append("id", this.departmentToDelete.id);
      data.append("departmentID", this.departmentToDelete.departmentID);
      data.append("department", this.departmentToDelete.department);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) =>{
            if (res.data.success) {
              this.successMessage = 'Department deleted successfully!';

              // Hide modal using vanilla JavaScript
              const deleteModalEl = document.getElementById('deleteModal');
              if (deleteModalEl) {
                const modal = window.bootstrap.Modal.getInstance(deleteModalEl);
                if (modal) {
                  modal.hide();
                }
              }

              this.departmentToDelete = null
              this.deleteConfirmText = ''
              this.getDepartment()

              // Clear success message after 3 seconds
              setTimeout(() => {
                this.successMessage = null
              }, 3000);
            } else {
              this.message = res.data.message

              // Hide modal using vanilla JavaScript
              const deleteModalEl = document.getElementById('deleteModal');
              if (deleteModalEl) {
                const modal = window.bootstrap.Modal.getInstance(deleteModalEl);
                if (modal) {
                  modal.hide();
                }
              }
            }
          })
          .catch((e) => {
            this.message = e.message

            // Hide modal using vanilla JavaScript
            const deleteModalEl = document.getElementById('deleteModal');
            if (deleteModalEl) {
              const modal = window.bootstrap.Modal.getInstance(deleteModalEl);
              if (modal) {
                modal.hide();
              }
            }
          });
    },
    toggleDepartmentStatus(item){
      this.departmentToToggle = item

      // Show modal using vanilla JavaScript
      const statusModalEl = document.getElementById('statusModal');
      if (statusModalEl) {
        const modal = new window.bootstrap.Modal(statusModalEl);
        modal.show();
      }
    },
    updateDepartmentStatus(){
      const newStatus = this.departmentToToggle.status === 'disabled' ? 'active' : 'disabled';

      const data = new FormData();
      data.append("function", "toggleDepartmentStatus");
      data.append("id", this.departmentToToggle.id);
      data.append("departmentID", this.departmentToToggle.departmentID);
      data.append("department", this.departmentToToggle.department);
      data.append("status", newStatus);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) =>{
            if (res.data.success) {
              this.successMessage = newStatus === 'disabled'
                  ? 'Department disabled successfully!'
                  : 'Department enabled successfully!';

              // Hide modal using vanilla JavaScript
              const statusModalEl = document.getElementById('statusModal');
              if (statusModalEl) {
                const modal = window.bootstrap.Modal.getInstance(statusModalEl);
                if (modal) {
                  modal.hide();
                }
              }

              this.departmentToToggle = null
              this.getDepartment()

              // Clear success message after 3 seconds
              setTimeout(() => {
                this.successMessage = null
              }, 3000);
            } else {
              this.message = res.data.message

              // Hide modal using vanilla JavaScript
              const statusModalEl = document.getElementById('statusModal');
              if (statusModalEl) {
                const modal = window.bootstrap.Modal.getInstance(statusModalEl);
                if (modal) {
                  modal.hide();
                }
              }
            }
          })
          .catch((e) => {
            this.message = e.message

            // Hide modal using vanilla JavaScript
            const statusModalEl = document.getElementById('statusModal');
            if (statusModalEl) {
              const modal = window.bootstrap.Modal.getInstance(statusModalEl);
              if (modal) {
                modal.hide();
              }
            }
          });
    }
  },
}
</script>

<style scoped>
.sources-table {
  font-size: 13px;
}

.sources-table th {
  font-weight: 600;
  background-color: #f8f9fa;
}

.sources-table tbody tr {
  transition: all 0.2s ease;
}

.sources-table tbody tr:hover {
  background-color: #f1f3f5;
  transform: scale(1.01);
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.modal-header {
  border-bottom: 2px solid rgba(0,0,0,.1);
}

.modal-footer {
  border-top: 2px solid rgba(0,0,0,.1);
}

.alert {
  border-left: 4px solid;
}

.alert-danger {
  border-left-color: #dc3545;
}

.alert-success {
  border-left-color: #28a745;
}

.alert-warning {
  border-left-color: #ffc107;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}
</style>